module.exports = __webpack_public_path__ + "img/current-goals.f27262c6.svg";